<template>
    <div class="tukivita_info_popup_main">
        <div class="tukivita_info_popup">
            <div class="tukivita_info_modal">
                <div class="tukivita_info_modal_center">
                    <div class="tukivita_info_inner">
                        <div class="p_ngo_close">
                            <router-link to="/" class="p_ngo_close_span"><i aria-hidden="true"
                                    class="fa fa-times-circle"></i></router-link>
                        </div>
                        <div class="tukivita_info_banner">
                            <img src="@/assets/images/kubrickheader.jpg" class="img-fluid">
                        </div>
                        <div class="tukivita_info_content">
                            <div class="container-fluid">
                                <div class="p_ngo_join_btn">
                                    <div class="row align-items-center">
                                        <div class="col-12 col-sm">
                                            <div class="row align-items-center">
                                                <div class="col">
                                                    <div class="ngo_title_wrp">
                                                        <span class="ngo_title">TukiVita AI Chatbot</span>
                                                    </div>
                                                    <div class="ngo_country_city">
                                                     Say Hello to TukiVita!
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="p_ngo_other_info pt-2">
                                    <!-- <h4 class="public_ngo_author">Website: <a href="https://www.pahs.edu.np/"
                                            class="ngo_website_link">https://www.pahs.edu.np/</a></h4> -->
                                    <!-- <h4 class="public_ngo_type_off">National Level NGO</h4> -->
                                    <div class="ngo_bio_text">
                                        <p>dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet.</p>
                                        <p>dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet.</p>
                                        <p>Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { bus } from '@/main';

const $ = window.jQuery = require('jquery');  
export default {
  name: 'tukivita-info',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {
    bus.$emit('showHeaderbtn', false);
  },
  methods: {

  },
  beforeCreate: function() {
    document.body.classList.add('left_sidebaar_disabled_for_page');
    document.body.classList.add('public_page_for_wrp_img');
  },
  beforeRouteLeave: function (to, from, next) {
    document.body.classList.remove('left_sidebaar_disabled_for_page');
    document.body.classList.remove('public_page_for_wrp_img');
    $(window).scrollTop(0);
    next();
  },
}
</script>

<style lang="scss" scoped>
.tukivita_info_popup_main {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    padding: 70px 15px 10px;

    .tukivita_info_popup {
        background: rgba(0, 0, 0, 0.92);
        padding: 20px 15px;

        .tukivita_info_inner {
            position: relative;
            padding-top: 30px;
        }

        .tukivita_info_modal {
            color: #fff;
            min-height: 100%;
            line-height: normal;
            font-size: 20px;
        }

        .tukivita_info_banner {
            height: 320px;
            overflow-y: hidden;
            border: 1px solid rgba(123, 134, 138, 0.15);

            .img-fluid {
                object-fit: cover;
                object-position: center center;
                width: 100%;
                height: 100%;
            }
        }

        .tukivita_info_content {
            padding: 20px 0;

            .tukivita_info_title {
                font-family: 'Beon';
                font-size: 24px;
                margin-bottom: 8px;
                color: #ffd400;
            }

            h4 {
                color: #d6d6d6;
                font-size: 18px;
                margin-bottom: 10px;

                &:last-child {
                    margin-bottom: 0px;
                }
            }

            p {
                color: #7c7c7c;
                font-size: 18px;
                line-height: 1.4;
            }

            .ngo_website_link {
                color: #ffd400;
                text-decoration: none;

                &:hover {
                    color: #87cefa;
                }
            }
        }

        .ngo_title_wrp {
            margin-bottom: 5px;

            .ngo_title {
                color: #ffe400;
                font-size: 28px;
                line-height: 1;

                // &:hover {
                //     color: #87cefa;
                // }
            }
        }

        .ngo_country_city {
            color: #ff9182;
            font-size: 18px;
            line-height: 1.3;
            text-transform: capitalize;
        }

        .p_ngo_join_btn {
            padding: 5px 20px;
            border-radius: 4px;

            @media only screen and (max-width:767px) {
                padding: 0px;
            }

            // border:1px solid rgba(123, 134, 138, 0.15);
            // background: linear-gradient(180deg, rgba(51,51,51,0.3) 0%, rgba(0,0,0,0.45) 100%);
            .btn-primary {
                font-family: 'ACETONE';
                background: none;
                border: 2px solid #ffe400;
                text-transform: uppercase;
                font-size: 28px;
                padding: 5px 8px;
                line-height: 1;
                height: auto;
                min-width: 110px;
                border-radius: 6px;
                box-shadow: none !important;
                box-sizing: none !important;
                outline: none !important;
                color: #ffe400;

                &:hover {
                    background: #ffe400;
                    color: #000000;
                }
            }
        }

        .p_ngo_other_info {
            padding: 10px 20px;

            @media only screen and (max-width:767px) {
                padding: 10px 0px;
            }
        }
    }

    .ngo_logo {
        // height: 80px;
        display: block;
    }

    .p_ngo_close {
        position: absolute;
        top: -10px;
        right: -5px;

        .p_ngo_close_span .fa {
            color: #e4002b;
            font-size: 30px;
            cursor: pointer;
            text-decoration: none;

            &:hover {
                color: #ffe400;
            }
        }
    }

    .ngo_bio_text {
        font-size: 17px;
        color: #a3a297;
    }
}
</style>